import React from "react";
import PropTypes from "prop-types";

import { useIntl } from "react-intl";

import Card from "@components/Card";
import Div from "@components/Div";
import { H4 } from "@components/Heading";
import { Text, TextMediumWeight } from "@components/Text";

const OrderItemsCard = ({ candidateName, companyName, orderDate, products }) => {
  const { messages } = useIntl();
  return (
    <Card
      borderRadius="10px"
      header={
        <Div
          width={1}
          px="24px"
          py={3}
          display="flex"
          gridGap="10px"
          flexDirection={["column", "column", "row"]}
          alignItems={["flex-start", "flex-start", "center"]}
          justifyContent={["flex-start", "flex-start", "space-between"]}
        >
          {[
            {
              title: messages.label_order_made_by,
              value: companyName,
            },
            {
              title: messages.title_person,
              value: candidateName,
            },
            { title: messages.label_date, value: orderDate },
          ].map(item => (
            <Div
              key={item.title}
              display="flex"
              flexDirection="column"
              gridGap={1}
            >
              <Text>{`${item.title}:`}</Text>

              <H4>{item.value}</H4>
            </Div>
          ))}
        </Div>
      }
    >
      <Div width={1} height={1} bg="var(--grey-lightest)" />

      <Div
        width={1}
        display="flex"
        flexDirection="column"
        px="24px"
        py={3}
        gridGap="12px"
      >
        <Text>{messages.heading_order_contains_following_services}</Text>

        {products.map(productName => (
          <Div
            key={productName}
            display="flex"
            flexDirection="column"
            gridGap={1}
          >
            <TextMediumWeight>{productName}</TextMediumWeight>
          </Div>
        ))}
      </Div>
    </Card>
  );
};

OrderItemsCard.propTypes = {
  companyName: PropTypes.string,
  candidateName: PropTypes.string,
  orderDate: PropTypes.string,
  products: PropTypes.array,
};

export default OrderItemsCard;
